import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { AccountService } from '../../core/auth/account.service';
import { AppConfigService } from '../../core/config/app-config.service';
import { AppEventService } from '../../core/event/app-event.service';
import { Account } from '../../core/user/account.model';

@Component({
  selector: 'app-access-denied',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterLink],
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
})
export class AccessDeniedComponent implements OnInit, OnDestroy {
  userName = '';
  locale = '';

  private subscriptions: Subscription[] = [];

  constructor(
    public accountService: AccountService,
    public translateService: TranslateService,
    private appConfigService: AppConfigService,
    private appEventService: AppEventService,
  ) {}

  ngOnInit(): void {
    // Subscribe to HTTP error events (replaces JhiEventManager)
    const errorSub = this.appEventService.subscribe('leanbyteApp.httpError').subscribe(content => {
      if (content?.error?.errorKey) {
        const context: Record<string, string> = {};
        if (content.error.params) {
          for (const param of content.error.params) {
            context[param.key] = param.value;
          }
        }
        const message = this.translateService.instant(content.error.errorKey, context);
        // TODO: Replace with PrimeNG MessageService when integrated
        console.error('[AccessDenied] HTTP Error:', message);
      }
    });
    this.subscriptions.push(errorSub);

    // Load user info from AccountService
    const authSub = this.accountService.getAuthenticationState().subscribe((account: Account | null) => {
      if (account) {
        this.userName = account.login;
        if (account.langKey) {
          this.translateService.use(this.locale || account.langKey);
        }
      }
    });
    this.subscriptions.push(authSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  isAllowed(): boolean {
    if (!this.accountService.userIdentity?.authorities?.length) {
      return false;
    }
    return true;
  }
}
